import React from 'react';
import { getSpecialtiesArray, HallType } from '../../config/halls';

const Hall: React.FC<{ hallData: HallType }> = ({ hallData }) => {
  const ref = React.useRef<HTMLImageElement>(null);
  const [imageLoaded, setImageLoaded] = React.useState(false);

  React.useEffect(() => {
    setImageLoaded(false);

    const onImageLoad = () => {
      setImageLoaded(true);
    };

    const onImageError = (event: Event) => {
      const img = event.target as HTMLImageElement;

      if (img.src.includes('.webp')) {
        img.src = `/images/halls/${hallData.id}.jpg`;
        return;
      }

      if (img.src.includes('.jpg')) {
        img.src = '/images/halls/notFound.jpeg';
        return;
      }

      setImageLoaded(true);
    };

    const img = ref.current;
    if (!img) return;

    img.src = `/images/halls/${hallData.id}.webp`;

    img.addEventListener('load', onImageLoad);
    img.addEventListener('error', onImageError);

    return () => {
      if (img) {
        img.removeEventListener('load', onImageLoad);
        img.removeEventListener('error', onImageError);
      }
    };
  }, [hallData.id]);

  return (
    <div
      className='w-[335px] rounded-[10px] border-[1px] border-[#007477] overflow-hidden bg-[#DEF0EF]'
      key={hallData.id}
    >
      <div className='relative'>
        <img
          ref={ref}
          alt={hallData.hallName}
          className='w-full rounded-t-[10px] mid:h-[222px] mid:object-cover'
          style={{
            opacity: imageLoaded ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out'
          }}
        />
      </div>
      <div className='flex flex-col items-center justify-evenly bg-white py-[10px]'>
        <AWrapper href={hallData.url}>
          <div className='flex flex-col items-center mb-[5px]'>
            <p
              className={`text-[18px] font-bold ${
                hallData.url && hallData.url !== '' ? 'underline' : ''
              } mb-[5px]`}
            >
              {hallData.hallName}
            </p>
            <p className='text-[14px]'>{hallData.address}</p>
          </div>
        </AWrapper>
        <div className='h-full mb-2 bg-white  flex flex-row justify-center items-center font-bold'>
          {hallData?.phoneNumber ?
            <>
              <img
                src='/images/phone_green.png'
                alt='phone_green'
                className='h-[21px] w-[21px] mr-[10px]'
              />
              <a
                href={`tel:${hallData.phoneNumber.replace(/-/g, '')}`}
                className='text-[22px] mid:pointer-events-none mid:cursor-default'
              >
                {hallData.phoneNumber}
              </a>
            </>
          : <div className='h-[33px] w-[21px] mr-[10px]'></div>}
        </div>

        <div className='flex flex-row gap-[8px]'>
          {hallData.offersPrivateFuneral && <GoldPanel>家族葬</GoldPanel>}
          {hallData.offersGeneralFuneral && <GoldPanel>一般葬</GoldPanel>}
          {hallData.offersCremation && <GoldPanel>火葬式</GoldPanel>}
        </div>
      </div>
      <div className='h-[30px] w-full bg-primary flex justify-center items-center text-[14px] text-white'>
        特徴
      </div>
      <div className='flex flex-wrap gap-[8px] px-[20px] py-[10px]'>
        {getSpecialtiesArray(hallData).map((specialty, index) => (
          <WhitePanel key={index}>{specialty}</WhitePanel>
        ))}
      </div>
    </div>
  );
};

const AWrapper: React.FC<{
  children: React.ReactNode;
  href: string | undefined;
}> = ({ href, children }) => {
  if (href && href.length > 0) {
    return (
      <a href={href} target='_blank' rel='noreferrer'>
        {children}
      </a>
    );
  } else {
    return <>{children}</>;
  }
};
const GoldPanel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className='bg-gold flex items-center justify-center rounded-[5px] px-[20px] py-[5px] text-white text-[16px] font-medium'>
    {children}
  </div>
);

const WhitePanel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className='bg-white flex items-center justify-center rounded-[5px] px-[10px] py-[6px] text-[12px]'>
    {children}
  </div>
);

export default Hall;
